import { titles } from './titles';

interface AppPage {
  url: string;
  key: string;
  title: string;
  component: string;
}

export const appPages: AppPage[] = [
  { key: 't1', url: '/puzzle/teil-1', component: 'page-teil-1', title: titles[1] },
  { key: 't2', url: '/puzzle/teil-2', component: 'page-teil-2', title: titles[2] },
  { key: 't3', url: '/puzzle/teil-3', component: 'page-teil-3', title: titles[3] },
  { key: 't4', url: '/puzzle/teil-4', component: 'page-teil-4', title: titles[4] },
  { key: 't5', url: '/puzzle/teil-5', component: 'page-teil-5', title: titles[5] },
  { key: 't6', url: '/puzzle/teil-6', component: 'page-teil-6', title: titles[6] },
  { key: 't7', url: '/puzzle/teil-7', component: 'page-teil-7', title: titles[7] },
  { key: 't8', url: '/puzzle/teil-8', component: 'page-teil-8', title: titles[8] },
  { key: 't9', url: '/puzzle/teil-9', component: 'page-teil-9', title: titles[9] },
  { key: 't10', url: '/puzzle/teil-10', component: 'page-teil-10', title: titles[10] },
  { key: 't11', url: '/puzzle/teil-11', component: 'page-teil-11', title: titles[11] },
  { key: 't12', url: '/puzzle/teil-12', component: 'page-teil-12', title: titles[12] },
];
